import {
  AUTH_COOKIE_NAME,
  COMMUNITY_COOKIE_NAME,
  APP_ENV,
  TTP_ONBOARDING_URL,
  TTP_HOME_URL,
  UA_DOMAIN_NAME,
} from "../config";

export function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}

export function setCookie(name, value, expires, path, domain, secure) {
  document.cookie =
    name +
    " = " +
    encodeURIComponent(value) +
    "  " +
    (!expires ? "" : "; expires = " + expires.toUTCString()) +
    (!path ? "" : "; path = " + path) +
    (!domain ? "" : "; domain = " + domain) +
    (secure === true ? "; secure" : "");
}

export const setCookieMaxAge = (name, value, options = {}) => {
  options = {
    path: "/",
    // add other defaults here if necessary
    ...options,
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie =
    encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
};

export const getAuthInfosFromCookie = () => {
  const cookie = getCookie(AUTH_COOKIE_NAME);

  if (!cookie) {
    return null;
  }

  return JSON.parse(cookie);
};

export const getCommunityFromCookie = () => {
  const cookie = getCookie(COMMUNITY_COOKIE_NAME);

  if (!cookie) {
    return null;
  }

  return JSON.parse(cookie);
};

export const authHasExpired = (authInfos) => {
  const now = Math.floor(new Date().getTime() / 1000);

  return (
    !authInfos ||
    typeof authInfos !== "object" ||
    !authInfos.createdAt ||
    !authInfos.expiresIn ||
    now >= parseFloat(authInfos.createdAt) + parseFloat(authInfos.expiresIn)
  );
};

export const getLocalStorageUser = () => {
  const stringUser = localStorage.getItem("user");
  let user = [];

  try {
    user = JSON.parse(stringUser);
  } catch (e) { }
  return user instanceof Object ? user : {};
};

export const getLocalStorageAuth = () => {
  const stringAuth = localStorage.getItem("auth");
  let auth = {};

  try {
    auth = JSON.parse(stringAuth);
  } catch (e) { }
  return typeof auth === "object" ? auth : {};
};

export const setLocalStorageAuth = (auth) => {
  if (typeof auth === "object") {
    localStorage.setItem("auth", JSON.stringify(auth));
    return auth;
  }
  if (auth == null) {
    localStorage.removeItem("auth");
  }
};

export const getLocalStorageCookie = () => {
  const stringAuth = localStorage.getItem("cookie_auth");
  let cookie_auth = null;

  try {
    cookie_auth = JSON.parse(stringAuth);
  } catch (e) { }
  return cookie_auth && typeof cookie_auth === "object" ? cookie_auth : null;
};

export const setLocalStorageCookie = (cookie_auth) => {
  if (cookie_auth && typeof cookie_auth === "object") {
    localStorage.setItem("cookie_auth", JSON.stringify(cookie_auth));
    return cookie_auth;
  }
  if (cookie_auth == null) {
    localStorage.removeItem("auth");
  }
};

export const logout = (redirect = true) => {
  let dtExpire = new Date();
  dtExpire.setTime(dtExpire.getTime() - 3600000 * 1000);

  setCookie(`ttp_auth_${APP_ENV}`, "", dtExpire, "/", "unitedassociates.be");
  setCookie(`ttp_auth_${APP_ENV}`, "", dtExpire, "/");

  setCookie(
    `ttp_community_${APP_ENV}`,
    "",
    dtExpire,
    "/",
    "unitedassociates.be"
  );
  localStorage.removeItem("teamCurrentUrl");

  if (redirect) {
    window.location.assign(`${TTP_ONBOARDING_URL}`);
  }
};

export const getUserCurrentNavCommunity = (user, currentNavCommunityId) => {
  if (
    currentNavCommunityId &&
    user.communities &&
    user.communities.length > 0
  ) {
    let currentUserNavCommunity = user.communities.filter(
      (c) => c.id === currentNavCommunityId
    )[0];
    if (currentUserNavCommunity) {
      return currentUserNavCommunity;
    }
  }
  return null;
};

export const createAuthCookie = (data) => {
  let dtExpire = new Date();
  dtExpire.setTime(dtExpire.getTime() - 3600000 * 1000);
  const expiry = Date.now() + data.token.expires_in;

  setCookieMaxAge(
    `ttp_auth_${APP_ENV}`,
    JSON.stringify({
      token: data.token.access_token,
      id: data.user.id,
      email: data.user.mainEmail,
      expiresIn: data.token.expires_in,
      createdAt: data.token.createdAt,
      expiry: expiry,
      scope: data.token.scope,
      // fullName: encodeURIComponent(
      //   data.user.firstName + " " + data.user.lastName
      // ),
    }),
    {
      "max-age": data.token.expires_in,
      expires: dtExpire,
      path: "/",
      domain: UA_DOMAIN_NAME,
    }
  );
};

export const createCommunityCookie = (data) => {
  let dtExpire = new Date();
  dtExpire.setTime(dtExpire.getTime() * 1000);
  // const expiry = Date.now() + data.token.expires_in;

  setCookieMaxAge(COMMUNITY_COOKIE_NAME, JSON.stringify(data), {
    // "max-age": data.token.expires_in,
    expires: dtExpire,
    path: "/",
    domain: UA_DOMAIN_NAME,
  });
};

export function updateAuthCookieGoPeopleOrganizationId(
  communityUuid,
  organizationUuid,
  organizationApiId
) {
  const cookieValue = getCookie(`ttp_auth_${APP_ENV}`);
  if (!cookieValue) return;

  let auth = {};
  try {
    auth = JSON.parse(cookieValue);
  } catch (e) {
    console.error("Invalid cookie JSON:", e);
    return;
  }
  auth.goPeopleOrganizationId = organizationUuid;
  auth.organizationGoApiId = organizationUuid;
  auth.communityApiId = organizationApiId;
  const dtExpire = new Date(
    parseInt(auth.createdAt) * 1000 + auth.expiresIn * 1000
  );

  setCookie(
    `ttp_auth_${APP_ENV}`,
    JSON.stringify(auth),
    dtExpire,
    "/",
    "unitedassociates.be"
  );
  setCookie(`ttp_auth_${APP_ENV}`, JSON.stringify(auth), dtExpire, "/");
}

export function transformGoApiUser(userData, selectedCommunity, organizationsData, userBlogRole) {
  if (!userData || !organizationsData) {
    return null;
  }
  const user = userData.user;
  // const selected = userData.selected_community;
  const selectedCommunityEntry = (organizationsData || []).find(
    (c) => c.ttp_community_id === selectedCommunity?.ttp_community_id
  );

  const selectedOrganization = organizationsData.find(
    (org) =>
      org.ttp_organization_id === selectedCommunity?.ttp_community_id
  );

  const enrichedBlogRole = []
    .concat(userBlogRole || [])
    .map((role) => ({
      ...role,
      organizationId: selectedOrganization?.ttp_organization_id || null,

      blogRoleInOrganization: (role.blogRoleInOrganization || []).map(
        (orgRole) => ({
          ...orgRole,
          organizationId:
            selectedOrganization?.ttp_organization_id || null,
        })
      ),
    }));
  const navCommunity = selectedOrganization
    ? {
      id: selectedOrganization.ttp_organization_id,
      uuid: selectedOrganization.uuid,
      uen: selectedOrganization.uen || "",
      name: selectedOrganization.official_name || "",
      abbreviation: selectedOrganization.short_name || "",
      avatarUrl: selectedOrganization.logo_url,
      logo_url: selectedOrganization.logo_url,
      communityUuid: selectedOrganization.community_id,
      selectedOrganization: selectedOrganization,
    }
    : null;
  const selectedRole = selectedCommunityEntry?.roles?.[0]?.role || null;

  const selectedRoleForCommunity = (userData.roles || []).find(
    (r) => r.community_id === selectedCommunity?.uuid
  );
  const uaRoles = (userData.communities || []).flatMap((community) => {
    const roleForCommunity = (userData.roles || []).find(
      (r) => r.community_id === community.uuid
    );

    let organizations = organizationsData
      .filter((org) => org.community_id === roleForCommunity.community_id)
      .map((org) => {
        return {
          id: org.ttp_organization_id,
          uuid: org.uuid,
          uen: org.uen || "",
          name: org.official_name || "",
          abbreviation: org.short_name || "",
          avatarUrl: org.logo_url,
          communityUuid: roleForCommunity.community_id,
          selectedOrganization:
            selectedCommunity.ttp_community_id === org.ttp_organization_id
              ? org
              : community,
        };
      });

    return [
      {
        id: community.ttp_community_id,
        community_id: roleForCommunity.community_id,
        function: community.community_name || "",
        type: roleForCommunity.role || "",
        typeStatus: roleForCommunity.type_status || "",
        validated: !!community.ua_status,
        internal: false,
        exist: false,
        createdAt: community.createdAt || new Date().toISOString(),
        organizations,
        organization: {
          id: selectedOrganization.ttp_organization_id,
          uuid: selectedOrganization.uuid,
          uen: selectedOrganization.uen || "",
          name: selectedOrganization.official_name || "",
          abbreviation: selectedOrganization.short_name || "",
          avatarUrl: selectedOrganization.logo_url,
          communityUuid: roleForCommunity.community_id,

        }
      },
    ];
  });

  const transformedUser = {
    id: user.ttp_user_id || null,
    firstName: user.firstname || "",
    lastName: user.lastname || "",
    mainEmail: user.email || "",
    mainPhone: user.phone || "",
    email: [{ email: user.email }, ...(user.secondary_emails || [])],
    phone: [{ phone: user.phone }, ...(user.secondary_phones || [])],
    language: user.main_language || "fr",
    gender: user.sex || "",
    function: "",
    type: "",
    enabled: true,
    acceptCookies: true,
    hasPassword: true,

    selectedCommunity: {
      ...selectedCommunity,
      id: selectedCommunity?.ttp_community_id,
    },
    blogRole: enrichedBlogRole,
    uaRoles,
    currentCommunity: selectedCommunity,
    communities: userData.communities || [],

    role: {
      id: selectedCommunity?.ttp_community_id,
      function: "",
      mandate: "",
      type: selectedRoleForCommunity.role,
      typeStatus: selectedRoleForCommunity?.type_status,
    },

    title: user.sex === "MALE" ? "Monsieur" : "Madame",
    salutation: user.sex === "MALE" ? "Cher Confrère" : "Chère Consœur",

    url: `${user.firstname}-${user.lastname}`
      .toLowerCase()
      .replace(/\s+/g, "-"),

    activityCount: 0,
    roles: [],
    description: "",
    isSecure: false,
    isUaAdmin: false,
    institute: "",
    numeroAgreation: "",
    userMobilePhone: { intlFormat: user.phone, countryCode: "be" },
    userSettings: { id: null, talkSettings: [] },
    type: user.type,
    isUaAdmin: user.is_ua_admin,
  };

  return {
    folder: [],
    role: {
      id: selectedCommunity?.ttp_community_id,
      type: selectedRoleForCommunity.role,
      typeStatus: selectedRoleForCommunity.type_status,
    },
    user: transformedUser,
    organization: selectedCommunity,
    navCommunity: navCommunity
  };
}

export function transformFidToOrganization(
  fid,
  organisationSettings,
  uaSettings
) {
  if (!fid) return null;

  return {
    ...organisationSettings,
    id: fid.ttp_organization_id ?? null,
    uen: fid.uen ?? "",
    name: fid.official_name ?? "",
    abbreviation: fid.short_name ?? "",
    address1: "",
    address2: "",
    city: "",
    zipCode: "",
    country: "",
    website: fid.website ?? "",
    legalForm: fid.legal_form ?? "",
    mandate: fid.mandate ?? "",
    type: fid.type ?? "",
    sector: {
      id: fid.sector_id ?? null,
    },
    latitude: null,
    longitude: null,
    avatarUrl: fid.logo_url,
    avatarWebPath: fid.cover_url ?? "",
    mastery: fid.mastery ?? null,
    legalRepresentative: fid.legalRepresentative ?? null,
    startDate: fid.start_date ?? null,
    uaStatus: fid.ua_status,
    onBoardingStep: fid.on_boarding_step,
    uaMode: fid.ua_mode,
    uaSettings: uaSettings,
    isClient: true,
    isActive: true,
  };
}
